import kr from 'Kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class HomeSlider extends kr.Component {
    init() {
        this.slider = new Swiper(this.$element.querySelector('.js--homeslider--slides'), {
            loop: false,
            autoplay: {
                delay: 7000,
            },
            effect: 'fade'
        });   
        this.buttons = this.$element.querySelectorAll('.js--homeslider--triggers [data-slide]');
        this._event();
    }
    
    _event() {
        this.slider.on('slideChange', (event) => {
            const slide = this.slider.slides[event.activeIndex];
            this._changeButtonActive(slide.getAttribute('data-slide'));
        });

        this.on('click', '.js--homeslider--triggers [data-slide]', (target, event) => {
            event.preventDefault();
            const slideName = target.getAttribute('data-slide');
            this._changeSlide(slideName);
        });

    }

    _changeSlide(name)
    {
        const index = this._findSlide(name);
        if (index === null) {
            return;
        }
        this.slider.slideTo(index);
    }

    _changeButtonActive(name)
    {
        for (let button of this.buttons) {
            if (button.getAttribute('data-slide') == name) {
                HTMLClass.addClass(button, 'active');
            } else {
                HTMLClass.removeClass(button, 'active');
            }
        }
    }

    _findSlide(name)
    {
        let foundSlide = null;
        for (let index in this.slider.slides) {
            if (!this.slider.slides.hasOwnProperty(index)) {
                continue;
            }
            const slide = this.slider.slides[index];
            if (slide.getAttribute('data-slide') == name) {
                foundSlide = index;
                break;
            }
        }

        return foundSlide;
    }
}

kr.registerComponent('.js--homeslider', {
    component: HomeSlider
});
